import { api_GET, api_POST, api_PUT, api_DELETE, api_GET_Unauthorize } from './_api';

const ramoDeAtividade_api = {
    GetList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET_Unauthorize(`RamoDeAtividade/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`RamoDeAtividade/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Post: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`RamoDeAtividade`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    Put: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`RamoDeAtividade`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default ramoDeAtividade_api;